import { FShallowNodeTypesEnum } from '@spazious/dollhouse-shallow-graph';

import { useLayers } from '../../hooks/useLayers.js';
import { AnnotationNode } from '../../types/index.js';

export type AnnotationProps = GraphNodeProps<AnnotationNode>;

export const Annotation: React.FC<AnnotationProps> = (props) => {
  const layers = useLayers();
  return (
    <annotation
      {...props}
      visible={props.visible !== false && layers.isEnabled(FShallowNodeTypesEnum.Annotation)}
    />
  );
};
